import { ProjectType } from '@/domain/project/entities/project.entity';

export function getScoreLetterFromKgeCO2PerParticipant(
  kgeCO2ByParticipant: number,
  projectType: ProjectType,
) {
  if (projectType === 'festival') {
    return festivalRule(kgeCO2ByParticipant);
  } else if (projectType === 'venue') {
    return venueRule(kgeCO2ByParticipant);
  } else {
    throw new Error('project type not supported');
  }
}

function festivalRule(kgeCO2ByParticipant: number) {
  if (isNaN(kgeCO2ByParticipant) || kgeCO2ByParticipant <= 0) {
    return '';
  } else if (kgeCO2ByParticipant < 25) {
    return 'A';
  } else if (kgeCO2ByParticipant < 40) {
    return 'B';
  } else if (kgeCO2ByParticipant < 60) {
    return 'C';
  } else if (kgeCO2ByParticipant < 90) {
    return 'D';
  } else {
    return 'E';
  }
}

function venueRule(kgeCO2ByParticipant: number) {
  if (isNaN(kgeCO2ByParticipant) || kgeCO2ByParticipant <= 0) {
    return '';
  } else if (kgeCO2ByParticipant < 15) {
    return 'A';
  } else if (kgeCO2ByParticipant < 25) {
    return 'B';
  } else if (kgeCO2ByParticipant < 35) {
    return 'C';
  } else if (kgeCO2ByParticipant < 50) {
    return 'D';
  } else {
    return 'E';
  }
}
